export const TAB = {
  UPCOMING: 'upcoming',
  PAST: 'past',
  GALLERY: 'gallery',
  PURCHASED: 'purchased',
};

export const TAB_LABEL = {
  [TAB.UPCOMING]: '今後のイベント',
  [TAB.PAST]: '過去のイベント',
  [TAB.GALLERY]: 'ギャラリー',
  [TAB.PURCHASED]: '購入済みイベント',
};

export const TABS_BY_ROLE = {
  artist: [TAB.UPCOMING, TAB.PAST, TAB.GALLERY],
  organizer: [TAB.UPCOMING, TAB.PAST, TAB.GALLERY],
  venue: [TAB.UPCOMING, TAB.PAST, TAB.GALLERY],
  buyer: [TAB.PURCHASED, TAB.PAST, TAB.GALLERY],
};
